/*=========================================================================================
  File Name: axiosConfig.js
  Description: Axios configuration. Axios is used for sending to server.
==========================================================================================*/

import axios from "axios";
import VueAxios from "vue-axios";
import { baseURL } from "./configuration";
import auth from "@websanova/vue-auth/dist/v2/vue-auth.esm.js";

export default function configureAxios(Vue) {
  Vue.use(VueAxios, axios);
  Vue.axios.defaults.baseURL = baseURL;
  Vue.axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";
  Vue.axios.defaults.headers.post["Accept"] = "application/json";
  Vue.axios.defaults.headers.common["Authorization"] = `Bearer ${
    localStorage[auth.tokenDefaultName]
  }`;
}
